
<template>
  <div style="width: 98%;height: 97%; background-color: #ffff">
    <!-- <div style="background-color: #fff; margin: 1%;border-radius: 5px;padding: 1%;">
      <el-row :gutter="20">
        <el-col :span="6" class="main-title">
          <el-avatar src="../../../../static/img/dd6f462.png"></el-avatar><span
            style="font-size: 18px;font-weight: bold;">东莞市建筑业协会</span>
          <span class="tip">会员</span>
        </el-col>
        <el-col :span="6">
          <span style="font-size: 12px;margin-left: 20.0025px;">会费缴纳情况：</span>
          <span style="font-size: 12px;" id="fee">本年已缴费</span>
        </el-col>
        <el-col :span="6">
          <span style="font-size: 12px;">最后登录时间：</span><span style="font-size: 12px;">2023年11月26日 18:15:07</span>
        </el-col>
      </el-row>
    </div> -->

    <div style="background-color: #fff; margin: 1%;border-radius: 5.0025px;padding: 1%;">
      <div style="margin-bottom: 20.0025px;"><span style="font-size: 18px;font-weight: bold;">申报统计</span><span
          style="font-size: 12px;margin-left: 20.0025px;">截今日为止</span></div>
      <el-row :gutter="20">
        <el-col :span="4">
          <div>
            <el-statistic title="项目申报总数">
              <template slot="formatter">
                {{projectCount}}
              </template>
            </el-statistic>
          </div>
        </el-col>

        <el-col :span="4">
          <div>
            <el-statistic title="项目待受理总数">
              <template slot="formatter">
                {{projectWaitCount}}
              </template>
            </el-statistic>
          </div>
        </el-col>
        <el-col :span="4">
          <div>
            <el-statistic title="项目已审核总数">
              <template slot="formatter">
                {{projectAuditCount}}
              </template>
            </el-statistic>
          </div>
        </el-col>

        <el-col :span="4">
          <div>
            <el-statistic title="会员注册总数">
              <template slot="formatter">
                {{memberCount}}
              </template>
            </el-statistic>
          </div>
        </el-col>
        <el-col :span="4">
          <div>
            <el-statistic title="专家注册总数">
              <template slot="formatter">
                {{expertCount}}
              </template>
            </el-statistic>
          </div>
        </el-col>
      </el-row>


    </div>
    <div id="container" style="background-color: #fff;margin: 1%;border-radius: 5.0025px;padding: 1%;">
      <el-row :gutter="20">
        <el-col :span="12">
          <div id="main">
          </div>
        </el-col>
        <el-col :span="12">
          <div id="main1">
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["reload"],
  data() {
    return {
      projectCount: '',
      projectWaitCount: '',
      projectAuditCount: '',
      memberCount: '',
      expertCount: '',
      memberWaitCount: '',
      expertWaitCount: ''
    };
  },
  mounted() {
    this.showCharts();
  },

  methods: {
    showCharts() {
      this.$axios({
        url: "/backstage/home/getHomeData",
        method: "get"
      }).then(res => {
        let data = res.data.data;
        console.log(data);
        this.projectCount = data.projectCount;
        this.projectWaitCount = data.projectWaitCount;
        this.projectAuditCount = data.projectAuditCount;
        this.memberCount = data.memberCount;
        this.expertCount = data.expertCount;
        this.memberWaitCount = data.memberWaitCount;
        this.expertWaitCount = data.expertWaitCount;
      }).catch(err => {
        console.log(err);
      })

      let myChart = this.$echarts.init(document.getElementById("main"));

      myChart.setOption({
        title: {
          left: 'center',
          text: '折线图'
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [150, 230, 224, 218, 135, 147, 260],
            type: 'line'
          },
          {
            data: [10, 20, 24, 28, 15, 17, 20],
            type: 'line'
          }
        ]
      });

      let myChart1 = this.$echarts.init(document.getElementById("main1"))

      myChart1.setOption({
        title: {
          left: 'center',
          text: '柱状图'
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130],
            type: 'bar'
          }
        ]
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.like {
  cursor: pointer;
  font-size: 24.9975px;
  display: inline-block;
}

#main {
  height: 399.9975px;
}

#main1 {
  height: 399.9975px;
}

.tip {
  box-sizing: border-box;
  height: 20.0025px;
  width: 57.9975px;

  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  font-size: 12px;
  background: #fff;
  border-radius: 9.9975px;
  margin: 0 14.0025px;
  border: .9975px solid #b6242b;
  color: #b6242b;
  padding-left: 15px;
  padding-right: 15px;
}

.main-title {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/system/index/index/mainIndex.vue